import { browser } from './browser-capabilities';
import { isInputableElement } from './is-inputable';
import { isChatIframe } from './messenger';

// Фиксит баг с пустым пространством под html при открытии виртуальной клавиатуры за счет скрытия клавиатуры при скролле
class VirtualKeyboardController {
    private hasOpenedKeyboard = false;

    public init() {
        if (browser()?.isSafariBased() && !browser()?.isFirefox() && browser()?.isMobile()) {
            window.addEventListener('scroll', this.handleScroll);
        }
    }

    private handleScroll = () => {
        const activeElement = document.activeElement;

        if (!(activeElement && activeElement instanceof HTMLElement)) {
            this.hasOpenedKeyboard = false;

            return;
        }

        const wasKeyboardOpened = this.hasOpenedKeyboard;

        const inputReceivedFocus = isInputableElement(activeElement);

        const hasScroll = window.innerHeight < document.documentElement.scrollHeight;

        // при фокусе инпута в айфрейме чата детектит появление клавиатуры по изменению вьюпорта и появлению скролла
        const inputInIframeReceivedFocus =
            isChatIframe(activeElement) &&
            hasScroll &&
            // предотвращает выставление флага на событие скролла в процессе закрытия клавиатуры
            window.innerHeight + window.scrollY === document.documentElement.clientHeight;

        this.hasOpenedKeyboard = inputReceivedFocus || inputInIframeReceivedFocus;

        // при открытии клавиатуры на фокус на инпуте происходит автоматический скрол к нему, поэтому на первоначальное событие блюрить не нужно
        if (!wasKeyboardOpened) {
            return;
        }

        if (this.hasOpenedKeyboard) {
            activeElement.blur();
            this.hasOpenedKeyboard = false;
        }
    };
}

export const initVirtualKeyboardController = () => {
    const virtualKeyboardController = new VirtualKeyboardController();
    virtualKeyboardController.init();
};
